module.exports = __webpack_public_path__ + "static/media/AvertaStd-Regular.19b8f54e.ttf";